// Damp + vannsprut i headeren (variant S4 «brytes opp» + E2-damp fra damp-header-test.html, 2. okt 2026).
// Én øse vann kastes fra nede til venstre mot venstre kant av logoen, så stiger dampen og legger seg øverst. Hvert 13. sek.
(() => {
  const boks = document.querySelector('.bg-damp'), hdr = boks && boks.parentElement;
  if (!boks) return;
  const c = boks.querySelector('canvas'), ctx = c.getContext('2d');
  const rolig = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const logo = () => [...hdr.querySelectorAll('.header__heading-link')].find(e => e.offsetWidth > 0);

  // Dampsky-sprite: fraktal verdi-støy inni en myk, ujevn kant.
  const lagSprite = (rgb, okt, fq) => {
    const N = 128, sp = document.createElement('canvas'); sp.width = sp.height = N;
    const s = sp.getContext('2d'), img = s.createImageData(N, N), [R, G, B] = rgb.split(',').map(Number);
    const G2 = 64, gitter = Array.from({ length: G2 * G2 }, Math.random);
    const glatt = t => t * t * (3 - 2 * t);
    const stoy = (x, y) => {
      const xi = Math.floor(x), yi = Math.floor(y), xf = glatt(x - xi), yf = glatt(y - yi);
      const v = (i, j) => gitter[((yi + j) & 63) * G2 + ((xi + i) & 63)];
      return (v(0,0) * (1 - xf) + v(1,0) * xf) * (1 - yf) + (v(0,1) * (1 - xf) + v(1,1) * xf) * yf;
    };
    const ox = Math.random() * 40, oy = Math.random() * 40;
    for (let y = 0; y < N; y++) for (let x = 0; x < N; x++) {
      let f = 0, amp = .5, fr = fq / N;
      for (let o = 0; o < okt; o++) { f += amp * stoy(ox + x * fr, oy + y * fr); amp *= .5; fr *= 2; }
      const dx = x / N - .5, dy = y / N - .5, d = Math.sqrt(dx * dx + dy * dy) * 2;
      const kant = Math.max(0, 1 - d - (f - .5) * .9);
      const a = Math.pow(Math.max(0, f - .28) / .72, 1.4) * Math.pow(Math.min(1, kant * 1.6), 1.5);
      const i = (y * N + x) * 4; img.data[i] = R; img.data[i+1] = G; img.data[i+2] = B; img.data[i+3] = a * 255;
    }
    s.putImageData(img, 0, 0);
    return sp;
  };

  // Innstillinger = S4 i testsiden.
  const o = { n: 14, a: .24, sp: 1, spread: .16, sway: .8, rmin: 70, rmax: 120, oct: 6, fq: 5, tint: '255,255,255',
              dr: 340, vifte: .32, mspread: 1.5, topp: .2, brudd: .85, tid: 200 };
  let sprites;                                              // lages i ledig tid etter at siden er lastet (se nederst)
  const fart = o.sp * (rolig ? .6 : 1), maxA = o.a * 1.6 * (rolig ? .7 : 1), sway = o.sway;
  const antall = Math.round(o.n * 1.7 * (rolig ? .8 : 1));
  const SYKLUS = 13000, UTBLAAS = 1200, LEVETID = 11500;
  let w, h, k = 1, dpr = 1, smal = false, synlig = true, p = [], neste = 0;
  const str = () => {
    w = hdr.clientWidth; h = hdr.clientHeight; smal = w < 750;
    dpr = Math.min(devicePixelRatio || 1, smal ? 1.5 : 2);   // mobil: maks 1,5 for jevnere tegning
    k = Math.min(1, h / 150);                               // mindre header (mobil) → mindre skyer og færre dråper
    c.width = w * dpr; c.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  str(); new ResizeObserver(str).observe(hdr);
  // ratio > 0: en skjult sticky-header ligger kant-i-kant over skjermen og teller ellers som «synlig».
  new IntersectionObserver(e => synlig = e[0].intersectionRatio > 0, { threshold: [0, .01] }).observe(hdr);

  const kast = (naa) => {
    for (let i = 0; i < antall; i++) {
      const x = w * (.5 + (Math.random() - .5) * 2 * o.spread);
      p.push({ fodt: naa + Math.random() * UTBLAAS, x, y: h + 20, mal: h * (.02 + Math.random() * .16),
        rMaal: (o.rmin + Math.random() * (o.rmax - o.rmin)) * k, bilde: sprites[i % 4], rot: Math.random() * 6.28, vr: (Math.random() - .5) * .002, vx: (x / w - .5) * (.05 + Math.random() * .08), t: Math.random() * 6.28 });
    }
  };

  // Fjerner døde partikler uten å lage en ny liste hver ramme.
  const behold = (arr, fn) => { let j = 0; for (let i = 0; i < arr.length; i++) if (fn(arr[i])) arr[j++] = arr[i]; arr.length = j; };
  const DR = o.dr, VIFTE = o.vifte, MSPREAD = o.mspread, TOPP = o.topp, BRUDD = o.brudd, TID = o.tid, g = .3, VANN = 'rgb(196,226,255)';
  const draaper = [], sprutDr = [], ringer = [];
  let igjen = 0;                                            // dråper som ennå ikke har truffet logoen i dette kastet
  const sprut = (naa) => {
    const el = logo(); if (!el) return kast(naa);
    const hr = hdr.getBoundingClientRect(), lr = el.getBoundingClientRect();
    const lx = lr.left - hr.left, ly = lr.top - hr.top, lw = lr.width, lh = lr.height;
    // Mobil (smal header): kastet kommer mer fra siden (lavere bue, start helt ute til venstre) og går ~1,9x saktere.
    const x0 = smal ? -6 : w * .13, y0 = h * (smal ? .92 : .88), gq = smal ? .05 : g;
    const TP = smal ? .5 : TOPP, VF = smal ? .15 : VIFTE, c1 = smal ? 5 : 10, c2 = smal ? 8 : 20;
    igjen = 0;
    for (let i = 0, n = Math.round(DR * Math.max(.5, k) * (smal ? .55 : 1)); i < n; i++) {
      const u = Math.random(), st = (Math.random() - .5) * (.15 + BRUDD * .4);
      const fodt = naa + (1 - u) * TID * .5 + Math.random() * TID * .5;
      const xs = x0 + (Math.random() - .5) * 14, ys = y0 + (Math.random() - .5) * 8;
      const tx = lx + lw * (.01 + Math.random() * .03), ty = ly + lh * (.5 + (u - .5) * MSPREAD + st);
      const topp = Math.min(h * (TP + VF * (.5 - u) + (Math.random() - .5) * .05), ty - c1, ys - c2);
      const vy = -Math.sqrt(2 * gq * (ys - topp)), T = (-vy + Math.sqrt(vy * vy + 2 * gq * (ty - ys))) / gq;
      const r = (Math.random() < .12 ? 1.6 + Math.random() * 1.6 : .5 + Math.random() * 1.1) * (smal ? .72 : 1);   // mobil: ~28 % mindre dråper
      const los = Math.random() < BRUDD * .35;
      const brytK = los ? T * (.25 + Math.random() * .55) : Infinity;
      draaper.push({ fodt, g: gq, x: xs, y: ys, vx: (tx - xs) / T, vy, k: 0, T, r, los, brytK, a: .35 + Math.random() * .45, l: (1.2 + Math.random() * 2.2) * (smal ? .72 : 1) });
      if (!los) igjen++;
    }
    if (!igjen) kast(naa);
  };
  const treff = (q, naa) => {
    if (!q.los && --igjen === 0) kast(naa + 250);          // dampen starter når siste dråpe faktisk har truffet
    // Mobil: mykere sprut i forhold til vannmengden (færre, saktere, mindre og kortere).
    const m = smal ? .55 : 1;
    if (Math.random() < (smal ? .15 : .35)) {
      const v = Math.PI * (1.05 + Math.random() * .9), f = (1.4 + Math.random() * 3.6) * m;
      sprutDr.push({ fodt: naa, liv: smal ? 500 : 800, x: q.x, y: q.y, vx: Math.cos(v) * f * 1.2 + q.vx * .3 * m, vy: Math.sin(v) * f - .8 * m, r: (.6 + Math.random() * 1.6) * (smal ? .75 : 1) });
    }
    if (Math.random() < .015) ringer.push({ fodt: naa, s: m, x: q.x, y: q.y });
  };
  const tegnSprut = (naa, dt) => {
    ctx.lineCap = 'round';
    behold(draaper, q => {
      if (naa < q.fodt) return true;
      q.vy += q.g * dt; q.x += q.vx * dt; q.y += q.vy * dt; q.k += dt;
      if (q.k >= q.brytK) { q.vx *= .65 + Math.random() * .2; q.vy += (Math.random() - .3) * 1.5; q.brytK = Infinity; q.T = Infinity; }
      if (q.k >= q.T) { treff(q, naa); return false; }
      if (q.y > h + 10) return false;
      const a = q.a * Math.min(1, q.k / 3);
      ctx.globalAlpha = a; ctx.strokeStyle = VANN; ctx.lineWidth = q.r;
      ctx.beginPath(); ctx.moveTo(q.x - q.vx * q.l, q.y - q.vy * q.l); ctx.lineTo(q.x, q.y); ctx.stroke();
      if (q.r > 1.5) { ctx.globalAlpha = a * .7; ctx.strokeStyle = '#fff'; ctx.lineWidth = q.r * .35; ctx.stroke(); }
      return true;
    });
    behold(sprutDr, q => {
      q.vy += .22 * dt; q.x += q.vx * dt; q.y += q.vy * dt;
      const liv = 1 - (naa - q.fodt) / q.liv; if (liv <= 0) return false;
      ctx.globalAlpha = .9 * liv; ctx.fillStyle = VANN;
      ctx.beginPath(); ctx.arc(q.x, q.y, q.r, 0, 6.28); ctx.fill();
      return true;
    });
    behold(ringer, q => {
      const t = (naa - q.fodt) / (450 * q.s); if (t >= 1) return false;
      ctx.globalAlpha = .3 * (1 - t); ctx.strokeStyle = VANN; ctx.lineWidth = 1.5;
      ctx.beginPath(); ctx.ellipse(q.x, q.y, (4 + t * 26) * q.s, (2 + t * 8) * q.s, 0, 0, 6.28); ctx.stroke();
      return true;
    });
    ctx.globalAlpha = 1;
  };

  let forrige;
  const loop = (naa) => {
    const dt = Math.min(50, naa - forrige) / 16.7; forrige = naa;
    if (synlig && !document.hidden) {
      if (naa >= neste) { sprut(naa); neste = naa + SYKLUS; }
      ctx.clearRect(0, 0, w, h);
      behold(p, q => naa - q.fodt < LEVETID);
      for (const q of p) {
        const alder = (naa - q.fodt) / LEVETID;
        if (alder < 0) continue;
        q.y += (q.mal - q.y) * .045 * fart * dt;
        const oppe = 1 - Math.min(1, Math.max(0, (q.y - q.mal) / h));
        q.x += (q.vx * oppe + Math.sin(q.t) * .1 * sway) * fart * dt;
        q.t += .01 * fart * dt;
        const r = q.rMaal * (.4 + .6 * Math.min(1, alder * 6) + alder * .9);
        const a = maxA * Math.min(1, alder * 14) * (alder < .55 ? 1 : 1 - (alder - .55) / .45);
        ctx.globalAlpha = Math.max(0, a);
        q.rot += q.vr * dt;
        // samme som translate + rotate + scale, uten save/restore per sky
        const cs = Math.cos(q.rot) * dpr, sn = Math.sin(q.rot) * dpr, sx = 1 + oppe * .35, sy = 1 - oppe * .4;
        ctx.setTransform(cs * sx, sn * sx, -sn * sy, cs * sy, q.x * dpr, q.y * dpr);
        ctx.drawImage(q.bilde, -r, -r, r * 2, r * 2);
      }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.globalAlpha = 1;
      tegnSprut(naa, dt);
    } else { neste = Math.max(neste, naa); }
    requestAnimationFrame(loop);
  };
  // Start først når siden er ferdig lastet og nettleseren er ledig: lag skyene da, så første kast ikke hakker.
  // Én sky per ledig stund (ingen lang blokk), og første kast i en egen ledig stund etterpå.
  const ledig = fn => window.requestIdleCallback ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 1200);
  const start = () => {
    sprites = sprites || [];
    if (sprites.length < 4) { sprites.push(lagSprite(o.tint, o.oct, o.fq)); return ledig(start); }
    requestAnimationFrame(t => { forrige = t; loop(t); });
  };
  if (document.readyState === 'complete') ledig(start); else addEventListener('load', () => ledig(start), { once: true });
})();
